import { SORTING_DIRECTION } from 'src/constants/main';
import { ILanguageTranslation } from 'src/types/languageTranslation';
import {
  ILanguageTranslationsFilters,
  ILanguageTranslationValidation,
  LANGUAGE_TRANSLATIONS_SORT_COLUMN,
  LANGUAGE_TRANSLATIONS_TYPE,
} from 'src/view/screens/SettingsScreen/screens/General/LanguageCountryCurrency/types/languageTranslations';

export const defaultLanguageTranslation: ILanguageTranslation = {
  id: 0,
  key: '',
  type: LANGUAGE_TRANSLATIONS_TYPE.BACKEND,
  translations: {
    en: '',
    ar: '',
  },
};

export const defaultLanguageTranslationsFilters: ILanguageTranslationsFilters = {
  search: '',
  type: LANGUAGE_TRANSLATIONS_TYPE.BACKEND,
  perPage: undefined,
  sortField: LANGUAGE_TRANSLATIONS_SORT_COLUMN.KEY,
  sortDir: SORTING_DIRECTION.ASCENDING,
};

export const defaultLanguageTranslationValidation: ILanguageTranslationValidation = {
  key: {
    state: true,
  },
  type: {
    state: true,
  },
  translations: {
    en: {
      state: true,
    },
    ar: {
      state: true,
    },
  },
};
